export default __webpack_public_path__ + "static/media/smallbookshelf.d3840b1a.png";